import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { login } from "../../../Services/Login/LoginService";

const Login = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    username: "",
    password: "",
  });

  const [errors, setErrors] = useState({
    username: "",
    password: "",
  });

  const [loading, setLoading] = useState(false); // Initialize loading state
  const [isLoggedIn, setIsLoggedIn] = useState(false); // Initialize login state

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = { ...errors };

    if (!formData.username) {
      newErrors.username = "Username is required";
    } else {
      newErrors.username = "";
    }

    if (!formData.password) {
      newErrors.password = "Password is required";
    } else {
      newErrors.password = "";
    }

    setErrors(newErrors);

    if (newErrors.username === "" && newErrors.password === "") {
      setLoading(true);

      const response = await login(formData);
      setLoading(false);
      if (response.success) {
        setIsLoggedIn(true);
        navigate("/candidate-listing");
      } else {
        alert(response.message);
      }
    }
  };

  return (
    <>
      <div className="container mt-5">
        <div className="row justify-content-center">
          <div className="col-lg-4 col-md-8 col-sm-10">
            <div className="card">
              <div className="card-body">
                <h1 className="card-title text-center">Login</h1>
                <p className="card-text text-medium-emphasis text-center">
                  Sign In to your account
                </p>
                <form onSubmit={handleSubmit}>
                  <div className="mb-3">
                    <label htmlFor="username" className="form-label">
                      Username
                    </label>
                    <input
                      type="text"
                      id="username"
                      name="username"
                      value={formData.username}
                      onChange={handleChange}
                      className={`form-control ${
                        errors.username ? "is-invalid" : ""
                      }`}
                      placeholder="Username"
                      autoComplete="username"
                    />
                    {errors.username && (
                      <div className="invalid-feedback">{errors.username}</div>
                    )}
                  </div>
                  <div className="mb-3">
                    <label htmlFor="password" className="form-label">
                      Password
                    </label>
                    <input
                      type="password"
                      id="password"
                      name="password"
                      value={formData.password}
                      onChange={handleChange}
                      className={`form-control ${
                        errors.password ? "is-invalid" : ""
                      }`}
                      placeholder="Password"
                      autoComplete="current-password"
                    />
                    {errors.password && (
                      <div className="invalid-feedback">{errors.password}</div>
                    )}
                  </div>
                  <div className="mb-3 text-center">
                    <button
                      type="submit"
                      className="btn btn-primary px-4"
                      disabled={loading}
                      style={{ minWidth: "120px" }}
                    >
                      {loading && (
                        <span
                          className="spinner-border spinner-border-sm me-2"
                          role="status"
                          aria-hidden="true"
                        ></span>
                      )}
                      Login
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
